<template>
  <div class="columns is-flex-wrap is-mobile is-1 is-variable">
    <div
      v-for="{ user_identity_token, picture, first_name, last_name } in attendees"
      :key="user_identity_token"
      class="column is-narrow"
      @click="$emit('open-user-modal', user_identity_token)"
    >
      <profile-picture class="is-60x60 profile-picture" :picture="picture"
                       :initials="initials(first_name, last_name)"></profile-picture>
    </div>
    <div v-if="isMoreAttendees" class="column is-narrow">
      <div class="circle-button has-text-weight-semibold has-text" @click="$emit('open-agenda-session-attendees')">
        {{ `+${moreAttendees}` }}
      </div>
    </div>
  </div>
</template>

<script>
import ProfilePicture from "@/shared/components/common/profile/ProfilePicture";

export default {
  name: "AttendeesList",

  components: {
    ProfilePicture,
  },

  props: ["attendees", "totalCount"],

  methods: {
    initials(firstName, lastName) {
      const a = ((firstName && firstName[0]) || "").toUpperCase();
      const b = ((lastName && lastName[0]) || "").toUpperCase();
      return `${a}${b}`;
    },
  },

  computed: {
    isMoreAttendees() {
      return this.moreAttendees > 0;
    },

    moreAttendees() {
      return this.totalCount - this.attendees.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.circle-button {
  width: 60px;
  height: 60px;
  margin: 0;
}

.profile-picture:hover {
  cursor: pointer;
}
</style>
